import { render, staticRenderFns } from "./CardItemLink.vue?vue&type=template&id=92c5159e&"
import script from "./CardItemLink.vue?vue&type=script&lang=js&"
export * from "./CardItemLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports